import {
  type AddBloggleIntegrationReq,
  type AddBloggleIntegrationRes,
  type AddShopifyIntegrationReq,
  type AddShopifyIntegrationRes,
  type AddWordpressIntegrationReq,
  type AddWordpressIntegrationRes,
  type DeleteIntegrationRes,
  type GetIntegrationsRes,
  type GetShopifyBlogsRes,
  type GetWordpressAuthorsRes,
  type GetWordpressPluginDownloadUrlRes,
  type UpdateIntegrationReq,
  type UpdateIntegrationRes,
  addBloggleIntegrationReqSchema,
  addShopifyIntegrationReqSchema,
  addWordpressIntegrationReqSchema,
  updateIntegrationReqSchema,
} from '../entity/api/routes/organization';
import { apiRequest } from './request';

export async function getOrganizationIntegrations(organizationId: string) {
  return apiRequest<GetIntegrationsRes>(`/organization/${organizationId}/integration`, 'GET', true);
}

export async function getShopifyBlogs(organizationId: string, integrationId: string) {
  const res = await apiRequest<GetShopifyBlogsRes>(
    `/organization/${organizationId}/integration/shopify/${integrationId}/blogs`,
    'GET',
    true
  );
  return res.data;
}

export async function addShopifyIntegration(
  organizationId: AddShopifyIntegrationReq['params']['id'],
  data: AddShopifyIntegrationReq['body']
) {
  const req = addShopifyIntegrationReqSchema.parse({
    params: { id: organizationId },
    query: null,
    body: data,
  });
  const res = await apiRequest<AddShopifyIntegrationRes>(
    `/organization/${req.params.id}/integration/shopify`,
    'POST',
    true,
    req.body
  );
  return res.data;
}

export function deleteOrganizationIntegration(organizationId: string, integrationId: string) {
  return apiRequest<DeleteIntegrationRes>(
    `/organization/${organizationId}/integration/${integrationId}`,
    'DELETE',
    true
  );
}

export async function updateOrganizationIntegration(
  organizationId: UpdateIntegrationReq['params']['id'],
  integrationId: UpdateIntegrationReq['params']['integrationId'],
  data: UpdateIntegrationReq['body']
) {
  const req = updateIntegrationReqSchema.parse({
    params: { id: organizationId, integrationId },
    query: null,
    body: data,
  });
  return apiRequest<UpdateIntegrationRes>(
    `/organization/${req.params.id}/integration/${req.params.integrationId}`,
    'PATCH',
    true,
    req.body
  );
}

export async function addBloggleIntegration(
  organizationId: AddBloggleIntegrationReq['params']['id'],
  data: AddBloggleIntegrationReq['body']
) {
  const req = addBloggleIntegrationReqSchema.parse({
    params: { id: organizationId },
    query: null,
    body: data,
  });

  const res = await apiRequest<AddBloggleIntegrationRes>(
    `/organization/${req.params.id}/integration/bloggle`,
    'POST',
    true,
    req.body
  );
  return res.data;
}

export async function getWordpressAuthors(
  organizationId: string,
  integrationId: string
): Promise<GetWordpressAuthorsRes['data']> {
  const res = await apiRequest<GetWordpressAuthorsRes>(
    `/organization/${organizationId}/integration/wordpress/${integrationId}/authors`,
    'GET',
    true
  );
  return res.data;
}

export async function getWordpressPluginDownloadUrl(
  organizationId: string
): Promise<GetWordpressPluginDownloadUrlRes['data']> {
  const res = await apiRequest<GetWordpressPluginDownloadUrlRes>(
    `/organization/${organizationId}/integration/wordpress/plugin-download-url`,
    'GET',
    true
  );
  return res.data;
}

export async function addWordpressIntegration(
  organizationId: AddWordpressIntegrationReq['params']['id'],
  data: AddWordpressIntegrationReq['body']
) {
  const req = addWordpressIntegrationReqSchema.parse({
    params: { id: organizationId },
    query: null,
    body: data,
  });

  const res = await apiRequest<AddWordpressIntegrationRes>(
    `/organization/${req.params.id}/integration/wordpress`,
    'POST',
    true,
    req.body
  );
  return res.data;
}
